<template>
  <div>
    <slot ref="tableElement"></slot>
  </div>
</template>

<script>
let $ = require("jquery");
require("datatables.net");
require("datatables.net-dt");
export default {
  name: "DataTable.vue",
  data(){
    return {
      table: {}
    }
  },
  mounted() {
    this.table = $(this.$el).find('table').DataTable({
      responsive: true,
    });
  }
}
</script>

<style scoped>

</style>
